module.exports = __webpack_public_path__ + "media/images/faq/brand2-3-c137aaacf8500b2423bbb5a5c469131c.png";